import React from "react";
import styled from "styled-components/macro";

import { Item } from "../../models/item";
import { useText } from "../../utilities/textUtil";

const Consequences = styled.div`
    padding: 0 25px 12px;
`;

const List = styled.div`
    & ul {
        padding-left: 20px;
    }
`;

export const ConsequenceList = ({ addedItems, removedItems }: { addedItems: Item[]; removedItems: Item[] }) => {
    const t = useText();
    return (
        <Consequences>
            {addedItems.length > 0 ? (
                <List>
                    <div>{t("addedItems")}</div>
                    <ul>
                        {addedItems.map(item => {
                            return <li key={item.id}>{item.displayText || item.retailerId || item.id}</li>;
                        })}
                    </ul>
                </List>
            ) : null}
            {removedItems.length > 0 ? (
                <List>
                    <div>{t("removedItems")}</div>
                    <ul>
                        {removedItems.map(item => {
                            return <li key={item.id}>{item.displayText || item.retailerId || item.id}</li>;
                        })}
                    </ul>
                </List>
            ) : null}
        </Consequences>
    );
};
